/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum NegotiationPackagesAliases {
  CARD_PACKAGE = 'card-package',
  CHECKBOX_0 = 'checkbox-0',
  CONTEXTUAL_BAR_0 = 'contextual-bar-0',
  DECK_0 = 'deck-0',
  FETCH_PACKAGE_DETAILS = 'fetch-package-details',
  FETCH_PACKAGES = 'fetch-packages',
  FIELD_0 = 'field-0',
  FIELD_2 = 'field-2',
  FIELD_AMOUNT = 'field-amount',
  FIELD_COUNTER_OFFER_VALUE = 'field-counter-offer-value',
  FIELD_COUNTER_OFFER_VALUE_DETAIL = 'field-counter-offer-value-detail',
  FIELD_DS_PROCEDURE = 'field-dsProcedure',
  FIELD_ITEM = 'field-item',
  FIELD_MAIN = 'field-main',
  FIELD_PACKAGE_VALUE = 'field-package-value',
  FIELD_PACKAGE_VALUE_DETAILS = 'field-package-value-details',
  FIELD_PACKAGE_VALUE_ORIGIN = 'field-package-value-origin',
  FIELD_TYPE = 'field-type',
  FILTER_0 = 'filter-0',
  FILTERED_LIST_0 = 'filtered-list-0',
  FORM_PACKAGE = 'form-package',
  HPMS_CUSTOM_LIST_FIELD = 'hpms-custom-list-field',
  INPUT_VALUE = 'input-value',
  LAYOUT_0 = 'layout-0',
  LEGENDS = 'legends',
  LOADER_0 = 'loader-0',
  MODAL_PACKAGE_DETAILS = 'modal-package-details',
  PANEL_0 = 'panel-0',
  PANEL_CARD_EDIT = 'panel-card-edit',
  PANEL_COMPOSITION_TITLE = 'panel-composition-title',
  PANEL_DETAILS = 'panel-details',
  PANEL_LIST_FIELD_ITENS = 'panel-list-field-itens',
  PANEL_LOADER = 'panel-loader',
  TEXT_0 = 'text-0',
  TEXT_1 = 'text-1',
  TEXT_2 = 'text-2',
  TEXT_3 = 'text-3',
  TEXT_4 = 'text-4',
  TEXT_5 = 'text-5',
  TEXT_6 = 'text-6',
  TEXT_7 = 'text-7',
  TEXT_9 = 'text-9',
  TEXT_10 = 'text-10',
  TEXT_11 = 'text-11',
}
export { NegotiationPackagesAliases };
